import Notify from 'quasar/src/plugins/Notify.js';;
Notify.setDefaults({
  position: 'bottom',
  timeout: 2500,
  color: 'green' //actions: [{ icon: 'close', color: 'white' }]

});